export class AssignAdapter {
  static toNodeAssignOutputDTO(res: any): any {
    if (!res || !res.edges || !res.nodes) return [];
    const { edges, nodes } = res;

    const options =
      nodes?.map((node: any) => ({
        id: node.value,
        key: node.value,
        value: false,
        meta: {
          label: node.name,
          layer: node.layer_no,
        },
      })) || [];

    const mapOptions = (key: any) =>
      options.map((option: any) => ({
        ...option,
        value: option.key === key,
      }));

    return (
      edges
        ?.filter((edge: any) => !!edge.client_edge_id)
        .map((edge: any) => {
          const nodePairId = edge?.node_pairs?.[0]?.node_pair_id;
          const sourceValue = edge?.node_pairs?.[0]?.source?.value;
          const targetValue = edge?.node_pairs?.[0]?.target?.value;
          return {
            id: edge.client_edge_id,
            node_pair_id: nodePairId,
            source: edge.doc_edge.source_term.value,
            source_options: {
              id: edge.doc_edge.source_term.term_id,
              key: edge.doc_edge.source_term.value,
              meta: {
                options: sourceValue ? mapOptions(sourceValue) : [],
              },
            },
            target: edge.doc_edge.target_term.value,
            target_options: {
              id: edge.doc_edge.target_term.term_id,
              key: edge.doc_edge.target_term.value,
              meta: {
                options: targetValue ? mapOptions(targetValue) : [],
              },
            },
            prohibit: [],
          };
        }) ?? []
    );
  }

  static toSimilarNodesInputDTO(req: any): any {
    return {
      term: req,
      n_result: -1,
    };
  }

  static toSimilarNodesOutputDTO(res: any, req: any): any {
    return (
      res?.map((attr: any) => ({
        id: attr.value,
        key: attr.value,
        value: attr.value === req,
        meta: {
          label: attr.name,
          layer: attr.layer_no,
        },
      })) || []
    );
  }

  static toNodeAssignInputDTO(req: any): any {
    return req.map((edge: any) => {
      const sourceOption = edge.source_options?.meta?.options?.find(
        (opt: any) => opt.value === true
      );
      const targetOption = edge.target_options?.meta?.options?.find(
        (opt: any) => opt.value === true
      );

      return {
        client_edge_id: edge.id,
        node_pair_id: edge?.node_pair_id ?? null,
        source_node_value: sourceOption?.key ?? null,
        target_node_value: targetOption?.key ?? null,
      };
    });
  }
}
